import React from 'react';
import './Presence.css';
import PresenceHero from '../images/portfolio-hero.jpg';
import Header from "../Header/Header"
import HeroSection from '../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Footer from '../Footer/Footer';
import ReactGA from 'react-ga';
class Presence extends React.Component {
    componentDidMount() {
        ReactGA.pageview('/presence/');
    }
    render() {
        window.scrollTo(0, 0);
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 2,
            dots: true,
            autoplay: true,
            responsive: [
                {
                breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                }
              ]
        };
       return (
        <div className="presence-page">
            <Header />
            <HeroSection background={PresenceHero} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/presence/" className="current">Presence</Link></li>
                    </ul>
                </Container>
                <div className="presence">
                    <h2 className="second-title"><i className="fa fa-circle"></i> <span>Presence </span><i className="fa fa-circle"></i></h2>
                    <Container>
                        <p className="text-center">We are present in more than 25+ Countries</p>
                    </Container>
                    <div className="presence-map"> </div>
                </div>
            </section>
            <Footer/>
        </div>
       );
    }
}
export default Presence;
